"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var SavedList = function (_a) {
    var recentList = _a.recentList, handleRecentSelection = _a.handleRecentSelection, customBoxVisible = _a.customBoxVisible, isHidden = _a.isHidden;
    var t = react_i18next_1.useTranslation('common').t;
    return !isHidden && customBoxVisible ? (react_1.default.createElement("div", { className: "custom-box" }, recentList.map(function (address, index) {
        var _a, _b;
        var main_text = ((_a = address.data) === null || _a === void 0 ? void 0 : _a.main_text) || '';
        var secondary_text = ((_b = address.data) === null || _b === void 0 ? void 0 : _b.secondary_text) || '';
        return (react_1.default.createElement("div", { onMouseDown: function () {
                handleRecentSelection(address);
            }, className: "item", key: index },
            react_1.default.createElement("div", { className: "cb-option-inner" },
                react_1.default.createElement("span", { className: "place-icon" }, address.type === 'my_location' ? (react_1.default.createElement("i", { className: "location arrow icon" })) : (react_1.default.createElement("i", { className: "cm-icon icon-ic-history" }))),
                react_1.default.createElement("div", { className: "place-info" },
                    react_1.default.createElement("div", null, main_text
                        ? main_text
                        : t('PLACES_AUTOCOMPLETE.GET_MY_LOCATION')),
                    react_1.default.createElement("div", { className: "secondary-text" }, secondary_text ? secondary_text : '')))));
    }))) : (react_1.default.createElement(react_1.default.Fragment, null));
};
exports.default = react_1.memo(SavedList);
